import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../../components/Table'
import SimpleCard from '../../components/templates/SimpleCard'
import { refundActions } from '../../redux/actions/refundActions'
import { format } from 'date-fns'
import toIDR from '../../utils/helpers/toIDR'
import ButtonIcon from '../../components/templates/ButtonIcon'
import { OpenInNew } from '../../assets/icons'
import templateStyles from '../../components/templates/templates.module.scss'

const MainTab = () => {
  const dispatch = useDispatch();
  const {
    items,
    tableConfig: {
      isLoading,
      page,
      totalData,
      limit,
      sort,
      filter
    }
  } = useSelector(state => state.refund);

  const load = useCallback(
    () => {
      const tConfig = {
        limit,
        page,
        sort,
        filter
      }
      return dispatch(refundActions.loadRequested(tConfig))
    },
    [dispatch, limit, page, sort, filter],
  )

  const setTableConfig = useCallback(
    key => value => dispatch(refundActions.setTableConfig(key, value)),
    [dispatch]
  )

  useEffect(() => {
    load()
  }, [load])

  const columns = useMemo(() => ([
    {
      title: 'Waktu Dibuat', key: 'createdAt', render: v => format(new Date(v), 'd MMM yyyy, HH:mm')
    },
    {
      title: 'Pemohon', key: 'company', render: v => `${v.name} - ${v.uniqueId}`
    },
    {
      title: 'Nominal', key: 'transaction', render: v => toIDR(v ? v.amount : 0)
    },
    {
      title: 'Kode Transaksi', key: 'transaction', render: v => v ? v.code : '-'
    },
    {
      title: 'Status', key: 'status'
    },
    {
      title: 'Action', key: '_id', render: (v, row) => (
        <div className={templateStyles.buttonGroup}>
          <ButtonIcon
            icon={<OpenInNew />}
            onClick={() => dispatch(refundActions.createTab(v, row.transaction?.code || `${row.company.name} - ${row.company.uniqueId}`))}
          />
        </div>
      )
    }
  ]), [dispatch]);

  const excelColumns = [
    { title: 'Waktu Dibuat', key: 'createdAt', render: v => format(new Date(v), 'd MMM yyyy, HH:mm') },
    { title: 'Pemohon', key: 'company', render: v => `${v.name} - ${v.uniqueId}` },
    { title: 'Nominal', key: 'transaction', render: v => toIDR(v.amount) },
    { title: 'Kode Transaksi', key: 'transaction', render: v => v.code },
    { title: 'Status', key: 'status' },
  ];

  return (
    <div>
      <SimpleCard>
        <Table
          data={items}
          excel={{
            columns: excelColumns,
            filename: 'Table Refunds'
          }}
          onReload={load}
          onChangePage={setTableConfig('page')}
          onSort={setTableConfig('sort')}
          config={{
            loading: isLoading,
            columns,
            total: totalData,
            limit,
            sort,
            currentPage: page,
            showRender: (from, to, total) => `${from}-${to} dari ${total} Transaksi`
          }}
        >
        </Table>
      </SimpleCard>
    </div >
  )
}

export default MainTab
